import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import AtlasPriceIndexSplineChart from 'src/components/AtlasV2Components/AtlasPriceV2PageComponents/AtlasPriceIndexSplineChart';
import AtlasPriceTopEntityChart from 'src/components/AtlasV2Components/AtlasPriceV2PageComponents/AtlasPriceTopEntityChart';
import { AtlasSalesV2ProductGrid } from 'src/components/AtlasV2Components/AtlasSalesV2PageComponents/AtlasSalesV2ProductGrid';
import { DorisMetricTypeEnum } from 'src/components/AtlasV2Components/Consts/DorisFieldNameEnum';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2 Price Summary Page layout - Tab name: prices subtab name: retailPrice
 */
export const AtlasPriceSummaryV2PageLayout = () => {
  const { isAllCategoriesEntity } = useCategoryEntity();
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <AtlasV2DorisSplineChart
          queryKey="retailPriceSplineChart"
          title="Retail Price"
          showAverageRate
          methodName="sales/GetSalesMetrics"
          metricTypeDisplay={METRICTYPE.MONEY}
          metricType="RetailPrice"
        />

        {!isAllCategoriesEntity && <AtlasPriceIndexSplineChart />}

        {!isProductEntity && <AtlasPriceTopEntityChart />}

        <AtlasSalesV2ProductGrid salesType={DorisMetricTypeEnum.RetailPrice} />
      </Flex>
    </BasePageContainer>
  );
};
